module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAALCAYAAABGbhwYAAAAAXNSR0IArs4c6QAAADVJREFUKFPtkbENACEAhLhFTNx/J827CC5g1O+lpoKoH1CShAWqwIjagHoQ+xN3Hf/luTozAdS8YXtcV2GgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2dmap/pause.png
// module id = bAiP
// module chunks = 2